import { createApp } from 'vue'
import StafetDonationTaendLysFlow from './StafetDonationTaendLysFlow'
import isObjectNotNullOrEmpty from 'foundation/js/isObjectNotNullOrEmpty'

const el = '.kb-component--stafet-donation-taend-lys-flow'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDonationTaendLysFlowDOM) => {
            const externalData = StafetDonationTaendLysFlowDOM.dataset.external
                ? JSON.parse(StafetDonationTaendLysFlowDOM.dataset.external)
                : null
            const props = {
                stafetId: externalData.stafetId ?? null,
                loggedIn: isObjectNotNullOrEmpty(externalData.userData),
                holdList: externalData.holdList ?? null,
                userData: isObjectNotNullOrEmpty(externalData.userData)
                    ? externalData.userData
                    : null,
                lysposeMinimumAmount: externalData.lysposeMinimumAmount ?? 50,
                holdId: externalData.holdId ?? '',
                deltagerId: externalData.deltagerId ?? ''
            }
            const component = createApp(StafetDonationTaendLysFlow, props).use(
                Store
            )
            component.mount(StafetDonationTaendLysFlowDOM)
        })
    }
}
